import {SelectField} from '@wandb/components';
import {
  type RepresentationType,
  RepresentationTypeValues,
} from '@wandb/weave/common/types/libs/nglviewer';
import React from 'react';

import {
  useMediaMoleculeConfigDisplay,
  useShouldShowMediaMoleculeConfigResetAtLevel,
} from '../../../hooks';
import {SettingTitle} from '../../common/SettingTitle';
import {useMediaSettingsContext} from '../../contexts/MediaSettingsContextProvider';

const OPTIONS = RepresentationTypeValues.map(representation => ({
  id: representation,
  label: representation,
}));

const isRepresentationType = (
  key: string | number | null
): key is RepresentationType =>
  RepresentationTypeValues.includes(key as RepresentationType);

export const RepresentationStyle = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const moleculeConfig = useMediaMoleculeConfigDisplay(settingsLevel, panelRef);
  const isSetAtLevel = useShouldShowMediaMoleculeConfigResetAtLevel(
    settingsLevel,
    panelRef
  );

  return (
    <div className="flex flex-col gap-y-12">
      <SettingTitle
        title="Representation style"
        configField="moleculeConfig"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('moleculeConfig')}
      />
      <SelectField
        items={OPTIONS}
        value={moleculeConfig?.representation ?? 'default'}
        onChange={key => {
          if (isRepresentationType(key)) {
            updateConfig({
              moleculeConfig: {...moleculeConfig, representation: key},
            });
          }
        }}
        aria-label="Representation style"
        fullWidth
      />
    </div>
  );
};
